import { useFormContext } from 'react-hook-form';
import { FilterField, FilterOptionType } from '../components/CaseFiltersForm/types';
import { FormState } from '..';

export const useFilterForm = () => {
  const { watch, setValue } = useFormContext<FormState>();

  const selectedTeams = watch('teams');
  const selectedWorkflows = watch('workflows');
  const selectedSteps = watch('steps');
  const selectedAgents = watch('agents');
  const selectedClients = watch('clients');

  const handleFilterChange = (field: FilterField) => (items: FilterOptionType[]) => {
    const ids = items.map((item) => item.id) as string[] | number[];

    setValue(field, ids, {
      shouldDirty: true,
    });
  };

  return {
    selectedTeams,
    selectedWorkflows,
    selectedSteps,
    selectedAgents,
    selectedClients,
    handleFilterChange,
  };
};
